import HelperService from '@/services/HelperService';
import axios from '@axios';

const baseUrl = 'api/v1/social-visits';
const helperService = new HelperService();
export default {
  getVisitsPaginated(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${baseUrl}/prison/paginated${queryString}`);
  },
  getApprovedVisits(visitLocationId) {
    let query = '?status=Approved';
    if (visitLocationId) {
      query += `&visitLocationId=${visitLocationId}`;
    }
    return axios.get(`${baseUrl}/prison${query}`);
  },
  getPreviousSocialVisits(visitorUserId) {
    return axios.get(`${baseUrl}/visitor-user/${visitorUserId}/previous-visits`);
  },
  rejectRequest(id, dto) {
    return axios.post(`${baseUrl}/reject/${id}`, dto);
  },
  getVisit(id) {
    return axios.get(`${baseUrl}/single-visit/${id}`);
  },
  approveRequest(id, dto) {
    return axios.post(`${baseUrl}/approve/${id}`, dto);
  },
  cancelVisit(id, dto) {
    return axios.post(`${baseUrl}/cancel/${id}`, dto);
  },
  bookVisitForVisitor(dto) {
    return axios.post(`${baseUrl}/book-visit`, dto);
  },
  getSocialVisitStats() {
    return axios.get(`${baseUrl}/prison/stats`);
  },
  removeAdditionalVisitor(visitId, additionalVisitorId, rejectionReason) {
    return axios.post(`${baseUrl}/additional-visitor/remove/${visitId}`, {
      additional_visitor_id: additionalVisitorId,
      rejection_reason: rejectionReason,
    });
  },
  addAdditionalVisitor(visitId, additionalVisitorId) {
    return axios.post(`${baseUrl}/additional-visitor/add/${visitId}`, {
      additional_visitor_id: additionalVisitorId,
    });
  },
  refundSocialKioskItems(visitId, dto) {
    return axios.post(`${baseUrl}/refund-kiosk-items/${visitId}`, dto);
  },
  fullRefundSocialKioskItems(visitId) {
    return axios.post(`${baseUrl}/refund-kiosk-items/full/${visitId}`);
  },
}
